var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.608 9.972h20.794M17.183 14.528h.01M12.005 14.528h.011M6.818 14.528h.01M17.183 19.062h.01M12.005 19.062h.011M6.818 19.062h.01M16.718 1.333v3.84M7.293 1.333v3.84",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.945 3.176H7.066C3.64 3.176 1.5 5.084 1.5 8.593V19.15c0 3.563 2.14 5.516 5.566 5.516h9.868c3.437 0 5.566-1.92 5.566-5.428V8.593c.01-3.509-2.118-5.417-5.555-5.417z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgIconCalendar;